import clsx from "clsx";
import EntryGrid from "components/EntryGrid";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";
import React from "react";
import { Seomatic } from "react-seomatic";

import PageTitle from "@components/PageTitle";
import Profile from "@components/Profile";
import { PreviewContent } from "@interfaces/PreviewContent.interface";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import QueryBlogCategory from "@queries/blog/QueryBlogCategory.graphql";
import QueryCategorySlugs from "@queries/QueryCategorySlugs.graphql";

export const getStaticPaths: GetStaticPaths = async (context) => {
	// Fetch every possible path
	const response = await craft(QueryCategorySlugs, {
		group: "postAuthors",
		limit: null
	});

	const paths = [];

	response.categories.map((category) => {
		console.log(`Generating /blog/author/${category.slug}`);

		paths.push({
			params: { authorSlug: category.slug }
		});
	});

	return { paths, fallback: "blocking" };
};

export const getStaticProps: GetStaticProps = async ({
	params,
	previewData: nextPreviewData,
	preview
}) => {
	// For Craft preview capability
	const previewData: PreviewContent = nextPreviewData as PreviewContent;

	// Construct uri from the slug array
	const { authorSlug } = params;

	// What is the uri
	const uri = `/blog/author/${authorSlug}`;

	// Fetch the page's data
	const response = await craft(QueryBlogCategory, {
		categorySlug: authorSlug,
		group: "postAuthors"
	});

	const {
		pageEntry,
		category,
		posts,
		blogCategories,
		primaryNavigation,
		primaryCallToActions,
		globalSet
	} = response;

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions
			},
			pageEntry,
			globalSet,
			author: category,
			posts,
			blogCategories
		},
		!category,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	author: any;
	posts: any[];
	blogCategories: any[];
}

const Page = ({
	pageEntry,
	author,
	posts,
	blogCategories
}: IProps): JSX.Element => {
	return (
		<>
			<Seomatic Head={Head} {...author.seomatic} />
			<PageTitle summary="Learn more about the Abnormal Intelligence authors.">
				Author Profile
			</PageTitle>
			<div className={clsx("mb-15")}>
				<Profile
					heading={author.title}
					role={author.role}
					biography={author.biography}
					image={!!author.image && author.image[0]}
					imageBlur={!!author.imageBlur && author.imageBlur[0]}
				/>
			</div>
			<div className={clsx("mb-15")}>
				<div className={clsx("max-w-screen-xl mx-auto")}>
					<EntryGrid
						entries={posts}
						indentMobile
						thumbnailAspectRatio="square"
					/>
				</div>
			</div>
		</>
	);
};

export default Page;
